export default __webpack_public_path__ + "static/media/misc-pantry2-1440w.c0a73fec.png";